// extracted by mini-css-extract-plugin
export default {"centered":"styles-module__centered__src-labstep-web-screens-Organization-Create-_dunn4"};